<template>
<nav id="purchase-nav">
  <ul class="nav nav-pills">
    <li>
      <router-link :to="{
        name: 'purchase_reports'
      }">
        Purchase Reports
      </router-link>
    </li>
    <li>
      <router-link :to="{
        name: 'create_purchase'
      }">
        New Purchase
      </router-link>
    </li>
    <li v-if="purchaseId">
      <router-link :to="{
        name: 'edit_purchase',
        params: { purchaseId: purchaseId }
        }"
      >
        Edit Purchase
      </router-link>
    </li>
  </ul>
</nav>
</template>

<script>
export default {
  props: ['purchaseId']
}
</script>

<style scoped>
main nav {
  margin-bottom: 1em;
}

.nav {
  border-top: 0
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseNav.vue